import { Box, Typography } from "@mui/joy";
import Add from "@mui/icons-material/Add";
import React, { useRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import { MenuItem } from "primereact/menuitem";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Toast } from "primereact/toast";
import { useNavigate } from "react-router-dom";
import { RouteComponentProps } from "../../../../models/RouteComponent";
import { FilterMatchMode } from "primereact/api";
import { GenericTableColumns } from "../../../../models/GenericTableViewModel";
import { GenericTableColumTypes, GenericTableFilterTypes } from "../../../../enum/TableView";
import GenericTableView from "../../../../components/GenericTableView";
import AddTasks from "./components/AddTasks";
import { siteJobTaskDelete } from "../../../../service/JobTaskService";

export default function JobTasks(props: RouteComponentProps) {
  const navigate = useNavigate();

  const [selectedRecord, setSelectedRecord] = useState({} as any);
  const [visible, setVisible] = useState(false);
  const [reload, setReload] = useState(false);
  const [equipmentIds, setEquipmentIds] = useState<string[]>([]);

  const toast = useRef(null as any);

  let url = "site-job-task";

  const baseFilter = {
    name: { value: "", matchMode: FilterMatchMode.CONTAINS },
    description: { value: "", matchMode: FilterMatchMode.CONTAINS },
    category_list: { value: '', matchMode: FilterMatchMode.CONTAINS },
    safe_work_method_name: { value: '', matchMode: FilterMatchMode.CONTAINS },
  };

  const deleteButton = (row: any) => {
    console.log("deleteButton row == ", selectedRecord);
    // removeClient(selectedRecord.id);
  };

  const addButton = (row: any) => {
    console.log("addButton row == ", row);
    // props.setGlobalLoader(true);
    setVisible(true);
  };

  const itemSelected = (row: any) => {
    const value = row.value;
    console.log("value == ", value);
    if (props.setEquipment) {
      console.log("Set Equipment ");
      props.setEquipment(value);
    }
    setSelectedRecord(value);
    DialogSetVisible(row);
    // navigate('/equipment-view');
  };

  const contextItemSelected = (row: any) => {
    console.log("contextItemSelected row == ", row);
    setSelectedRecord(row.value);
  };

  const acceptFunc = async () => {
    props.setGlobalLoader(true);
    const client = await siteJobTaskDelete(selectedRecord.id);
    props.setGlobalLoader(false);
    toast.current.show({
      severity: "success",
      summary: "Job Task Deleted Successfully",
      life: 3000,
    });
    setReload(!reload);
  };

  const deleteConfirm = (row: any) => {
    confirmDialog({
      message: "Are you sure you want to proceed?",
      header: "Confirmation",
      icon: "pi pi-exclamation-triangle",
      accept: () => acceptFunc(),
    });
  };

  const DialogSetVisible = (row: any) => {
    setVisible(true);
  };

  const viewSelected = (row: any) => {
  };

  const contextItems = () => {
    let objArray = [
      // { label: 'View', icon: 'pi pi-fw pi-eye', command: viewSelected },
      // { label: "Edit", icon: "pi pi-fw pi-pencil", command: DialogSetVisible },
    ];
    objArray.push({ label: "Delete", icon: "pi pi-fw pi-trash", command: deleteConfirm });
    return objArray;
  };

  const columns: GenericTableColumns[] = [
    {
      field: "name",
      header: "Name",
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: true,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [
          {
            label: "",
            value: "",
          },
        ],
      },
    },
    {
      field: "description",
      header: "Description",
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: false,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [
          {
            label: "",
            value: "",
          },
        ],
      },
    },
    {
      field: "category_list",
      header: "Categories",
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: false,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [
          {
            label: "",
            value: "",
          },
        ],
      },
    },
    {
      field: "safe_work_method_name",
      header: "Safe work method",
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: false,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [
          {
            label: "",
            value: "",
          },
        ],
      },
    }
  ];

  return (
    <React.Fragment>
      <Box
        sx={{
          display: "flex",
          mb: 1,
          gap: 1,
          flexDirection: { xs: "column", sm: "row" },
          alignItems: { xs: "start", sm: "center" },
          flexWrap: "wrap",
          justifyContent: "space-between",
        }}
      >
        <Typography level="h2" component="h1">
          Job Tasks
        </Typography>

        {/* <Button
            color="primary"
            startDecorator={<Add />}
            size="sm"
            onClick={() => setVisible(true)}
          >Add</Button> */}
      </Box>

      <GenericTableView
        reload={reload}
        baseFilters={baseFilter}
        url={url}
        columns={columns}
        contextItems={contextItems}
        addButton={addButton}
        // itemSelect={itemSelected}
        contextItemSelected={contextItemSelected}
        callbackOnLoad={(data: any) => {
          setEquipmentIds(data.map((item: any) => item.equipment) || []);
        }}
      />

      <Dialog
        header={selectedRecord?.id ? "Update Job Tasks" : "Add Job Tasks"}
        visible={visible}
        style={{ width: "95vw", height: "75vh", maxWidth: "1440px" }}
        onHide={() => setVisible(false)}
      >
        <AddTasks
          setGlobalLoading={props.setGlobalLoader}
          setReload={setReload}
          reload={reload}
          setVisible={setVisible}
          toast={toast}
          session={props.session}
        />
      </Dialog>

      <ConfirmDialog />

      <Toast ref={toast} />
    </React.Fragment>
  );
}
